"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntendedCreditStep = void 0;

var _react = _interopRequireDefault(require("react"));

var _modal = require("@creditas-lab/modal");

var _typography = require("@creditas-lab/typography");

var _services = require("../../services");

var _Stepper = require("../Stepper");

var _hooks = require("../../hooks");

var _constants = require("../../constants");

var _icons = require("../../icons");

var _CreditRangeInput = require("../CreditRangeInput");

var _IntendedCreditStep = require("./IntendedCreditStep.style");

var _core = require("@emotion/core");

var IntendedCreditStep = function IntendedCreditStep() {
  var _ref = (0, _Stepper.useStepper)(),
      next = _ref.next;

  var _ref2 = (0, _hooks.useSimulator)(),
      intendedCredit = _ref2.intendedCredit,
      setIntendedCredit = _ref2.setIntendedCredit,
      closeSimulator = _ref2.closeSimulator;

  var handleNextStepClick = function handleNextStepClick() {
    (0, _services.dispatchNextStepClickEvent)(_constants.Steps.IntendedCredit);
    if (!intendedCredit) return;
    next();
  };

  var handleCreditRangeInputChange = function handleCreditRangeInputChange(value) {
    if (value !== intendedCredit) {
      setIntendedCredit(value);
    }
  };

  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_IntendedCreditStep.ModalHeader, {
    onClose: closeSimulator
  }), (0, _core.jsx)(_modal.ModalBody, null, (0, _core.jsx)(_IntendedCreditStep.Container, null, (0, _core.jsx)(_IntendedCreditStep.Container.Header, null, (0, _core.jsx)(_typography.Typography, {
    desktop: "lg",
    mobile: "sm"
  }, "De quanto voc\xEA precisa?")), (0, _core.jsx)(_IntendedCreditStep.Container.Body, null, (0, _core.jsx)(_CreditRangeInput.CreditRangeInput, {
    initialValue: intendedCredit,
    onChange: handleCreditRangeInputChange
  })), (0, _core.jsx)(_IntendedCreditStep.Container.Footer, null, (0, _core.jsx)(_IntendedCreditStep.NextButton, {
    onClick: handleNextStepClick,
    "data-testid": "next-step-button"
  }, (0, _core.jsx)(_icons.ArrowRight, null))))));
};

exports.IntendedCreditStep = IntendedCreditStep;
IntendedCreditStep.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "IntendedCreditStep"
};